import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

/** Firebase (+ GA4) 설정 */
const firebaseConfig = {
  apiKey: 'AIzaSyANhpHQkNS1d16HI-AHpL_xXC40brVMmLA',
  authDomain: 'dealerweb-61add.firebaseapp.com',
  projectId: 'dealerweb-61add',
  storageBucket: 'dealerweb-61add.appspot.com',
  messagingSenderId: '247881049483',
  appId: '1:247881049483:web:866aa4ff801dbda35a7b8e',
  measurementId: 'G-03E2M106S4',
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export const analytics = typeof window !== "undefined" ? getAnalytics(firebaseApp) : null;

export default firebaseApp;